var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10V6C4 4.93913 4.42143 3.92172 5.17157 3.17157C5.92172 2.42143 6.93913 2 8 2C9.06087 2 10.0783 2.42143 10.8284 3.17157C11.5786 3.92172 12 4.93913 12 6V11.3333C12 12.0406 11.719 12.7189 11.219 13.219C10.7189 13.719 10.0406 14 9.33333 14C8.62609 14 7.94781 13.719 7.44772 13.219C6.94762 12.7189 6.66667 12.0406 6.66667 11.3333V6C6.66667 5.64638 6.80714 5.30724 7.05719 5.05719C7.30724 4.80714 7.64638 4.66667 8 4.66667C8.35362 4.66667 8.69276 4.80714 8.94281 5.05719C9.19286 5.30724 9.33333 5.64638 9.33333 6V11.3333",
    stroke: "#A7A7A7",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAttach);
export default __webpack_public_path__ + "static/media/chat-attach.a630078624af75b1b572e6b6a4ca3e2b.svg";
export { ForwardRef as ReactComponent };